import { makeStyles, mergeClasses, tokens } from '@fluentui/react-components';
import { ReactElement, ReactNode } from 'react';

const useStyles = makeStyles({
  root: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: tokens.spacingHorizontalXS,
  },
  icon: {
    display: 'flex',
    alignItems: 'center',
  },
});

type TIconLabelProps = {
  icon: ReactElement;
  children: ReactNode;
  className?: string;
};

/**
 * Simple inline component displaying an icon followed by text.
 * Inherits font size and color from parent. Use className for custom styling.
 */
const IconLabel = ({ icon, children, className }: TIconLabelProps) => {
  const classes = useStyles();

  return (
    <span className={mergeClasses(classes.root, className)}>
      <span className={classes.icon}>{icon}</span>
      {children}
    </span>
  );
};

export { IconLabel };
